<template>
    <!-- Modal Component -->
    <b-modal id="modal_gerarcteajustado"
             ref="modal_gerarcteajustado"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             v-model="showModalGerarCteAjustado"
             :ok-disabled=form.errors.any()
             size="lg">
    <b-container fluid class="p-a-0">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-container fluid class="p-a-0">
                <b-row>
                  <b-col>
                      <label>CST</label>
                      <multiselect v-model="form.cst"
                      :options="optionsParamCst"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('cst.value')" v-if="form.errors.has('cst.value')"></b-form-feedback>
                  </b-col>

                    <b-col>
                        <label>CFOP</label>
                        <multiselect v-model="form.cfop"
                        :options="optionsCfop"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('cfop.value')" v-if="form.errors.has('cfop.value')"></b-form-feedback>
                    </b-col>

                    <b-col>
                        <label>Tipo serviço</label>
                        <multiselect v-model="form.tp_servico"
                        :options="optionsLivTpServico"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        disabled
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('tp_servico.value')" v-if="form.errors.has('tp_servico.value')"></b-form-feedback>
                    </b-col>

                    <b-col>
                        <label>Modal</label>
                        <multiselect v-model="form.bmodal"
                        :options="optionsBModal"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        disabled
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('bmodal.value')" v-if="form.errors.has('bmodal.value')"></b-form-feedback>
                    </b-col>
                </b-row>
                <b-row v-if="form.tp_servico.value==4">
                  <b-col>
                      <label>Chave CTE Multimodal</label>
                      <b-form-input type="text"
                                  placeholder="Chave"
                                  v-model="form.chave_cte_multi"
                                  name="chave_cte_multi"
                                  >
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('chave_cte_multi')" v-if="form.errors.has('chave_cte_multi')"></b-form-feedback>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Municipio Inicio</label>
                        <multiselect v-model="form.municipio_ini"
                        :options="optionsMunicipioIni"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        disabled
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_ini.value')" v-if="form.errors.has('municipio_ini.value')"></b-form-feedback>
                    </b-col>

                    <b-col>
                        <label>Municipio Fim</label>
                        <multiselect v-model="form.municipio_fim"
                        :options="optionsMunicipioFim"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        disabled
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_fim.value')" v-if="form.errors.has('municipio_fim.value')"></b-form-feedback>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Produto Predominante</label>
                        <b-form-input type="text"
                                    placeholder="Produto Predominante"
                                    v-model="form.produto_predominante"
                                    name="produto_predominante"
                                    class="form-control"
                                    >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('produto_predominante')" v-if="form.errors.has('produto_predominante')"></b-form-feedback>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <br/>
                        <h3 class="panel-title with-border">Valores</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label>Valor Liquido</label>
                        <input v-model.lazy="form.vlr_cte"
                             v-money="vlr"
                             v-on:keyup="calcCte"
                             name="vlr_cte"
                             type="text"
                             class="form-control"
                             style="text-align: right" readonly/>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                    </b-col>
                    <b-col>
                        <label>Alíquota</label>
                        <input v-model.lazy="form.vlr_aliquota"
                               v-money="aliquota"
                               v-on:keyup="calcCte"
                               name="vlr_aliquota"
                               type="text"
                               class="form-control"
                               style="text-align: right" readonly/>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                    </b-col>
                    <b-col>
                        <label>Imposto</label>
                        <input v-model.lazy="form.vlr_imposto"
                             v-money="vlr"
                             name="vlr_imposto"
                             type="text"
                             class="form-control"
                             style="text-align: right" readonly/>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                    </b-col>

                    <b-col v-if="this.form.cst.cd=='90' || this.form.cst.cd=='20'">
                        <label>% Redução BC</label>
                        <input v-model.lazy="form.percentual_reducao_bc"
                               v-money="percentual_reducao_bc"
                               name="percentual_reducao_bc"
                               type="text"
                               class="form-control"
                               style="text-align: right" readonly/>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_reducao_bc')" v-if="form.errors.has('percentual_reducao_bc')"></b-form-feedback>
                      </b-col>

                 <b-col>
                    <label>Valor Total do CTE</label>
                    <input v-model.lazy="form.vlr_total"
                           v-money="vlr"
                           name="vlr_total"
                           type="text"
                           class="form-control"
                           readonly="true"
                           style="text-align: right" />
                      <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                  </b-col>
                  <b-col>
                    <label>Valor Averbação</label>
                      <b-form-input type="text"
                                    v-money="vlr"
                                    placeholder="Valor Averbação"
                                    v-model="form.vlr_carga_averbacao"
                                     readonly>
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_carga_averbacao')" v-if="form.errors.has('vlr_carga_averbacao')"></b-form-feedback>
                  </b-col>
                </b-row>

            </b-container>

            <div v-if="this.form.modal==3">
                <b-row>
                    <b-col>
                        <br/>
                        <h3 class="panel-title with-border">CTE <b-badge> Aquaviário </b-badge></h3>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col>
                      <label>Porto de Origem</label>
                      <multiselect v-model="form.porto_origem"
                      :options="optionsPortoOrigem"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      disabled
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_origem.value')" v-if="form.errors.has('porto_origem.value')"></b-form-feedback>
                    </b-col>
                    <b-col>

                      <label>Porto de Transbordo</label>
                      <multiselect v-model="form.porto_transbordo"
                      :options="optionsPortoTransbordo"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      disabled
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_transbordo.value')" v-if="form.errors.has('porto_transbordo.value')"></b-form-feedback>
                    </b-col>
                    <b-col>

                      <label>Porto de Destino</label>
                      <multiselect v-model="form.porto_destino"
                      :options="optionsPortoDestino"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      disabled
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_destino.value')" v-if="form.errors.has('porto_destino.value')"></b-form-feedback>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <label>Embarcação</label>
                      <multiselect v-model="form.embarcacao"
                      :options="optionsEmbarcacao"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      disabled
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('embarcacao.value')" v-if="form.errors.has('embarcacao.value')"></b-form-feedback>
                    </b-col>
                  <b-col>
                      <label>Número da Viagem</label>
                      <b-form-input type="text"
                                    placeholder="Número da Viagem"
                                    v-model="form.num_viagem"
                                    name="num_viagem"

                                    readonly>
                      </b-form-input>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('num_viagem')" v-if="form.errors.has('num_viagem')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>% Afrmm</label>
                    <input v-model.lazy="form.vlr_aliquota_afrmm"
                       v-money="aliquota"
                       name="vlr_aliquota_afrmm"
                       type="text"
                       class="form-control"
                       style="text-align: right" />
                    <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota_afrmm')" v-if="form.errors.has('vlr_aliquota_afrmm')"></b-form-feedback>
                </b-col>
            </b-row>
          </div>
          <div v-if="this.form.bmodal.cd==1">
              <b-row>
                  <b-col>
                      <br/>
                      <h3 class="panel-title with-border">CTE <b-badge> Rodoviário </b-badge></h3>
                  </b-col>
              </b-row>
              <b-row>
              <b-col>
                  <label>RNTRC</label>
                  <input v-model.lazy="form.rntrc"
                     name="rntrc"
                     type="text"
                     class="form-control"/>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('rntrc')" v-if="form.errors.has('rntrc')"></b-form-feedback>
              </b-col>
          </b-row>
        </div>
            <b-container fluid class="p-a-0">
              <b-row>
                <b-col>
                    <br/>
                    <h3 class="panel-title">Detalhes do CTE </h3>
                    <b-tabs>
                      <b-tab title="Partes Envolvidas" active>
                          <b-row>
                              <b-col>
                                <label>Expedidor</label>
                                <multiselect v-model="form.expedidor"
                                :options-limit="300"
                                :limit="2"
                                :limit-text="limitText"
                                :options="optionsExpedidor"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                :searchable="true"
                                :loading="isLoadingExp"
                                @search-change="listaClientesExpedidor"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('expedidor')" v-if="form.errors.has('expedidor')"></b-form-feedback>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col>
                                <label>Recebedor</label>
                                <multiselect v-model="form.recebedor"
                                :options-limit="300"
                                :limit="2"
                                :limit-text="limitText"
                                :options="optionsRecebedor"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Recebedor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                :searchable="true"
                                :loading="isLoadingRec"
                                @search-change="listaClientesRecebedor"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('recebedor')" v-if="form.errors.has('recebedor')"></b-form-feedback>
                              </b-col>
                          </b-row>

                          <b-row>
                              <b-col>
                                  <label>Tomador</label>
                                    <b-form-radio-group buttons button-variant="secondary" v-model="form.tomador" name="tomador">
                                      <b-form-radio value="0"> Remetente</b-form-radio>
                                      <b-form-radio value="1"> Expedidor</b-form-radio>
                                      <b-form-radio value="2"> Recebedor</b-form-radio>
                                      <b-form-radio value="3"> Destinatário</b-form-radio>
                                      <b-form-radio value="4"> Outros</b-form-radio>
                                    </b-form-radio-group>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('tomador')" v-if="form.errors.has('tomador')"></b-form-feedback>
                                </b-col>
                            </b-row>
                            <b-row v-if="form.tomador==4">
                                <b-col>
                                  <label>Tomador - Outros</label>
                                  <multiselect v-model="form.tomador_outros"
                                  :options-limit="300"
                                  :limit="2"
                                  :limit-text="limitText"
                                  :options="optionsTomador"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  :searchable="true"
                                  :loading="isLoadingTom"
                                  @search-change="listaClientesTomador"
                                  ></multiselect>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tomador_outros.value')" v-if="form.errors.has('tomador_outros.value')"></b-form-feedback>
                                </b-col>
                            </b-row>
                      </b-tab>
                      <b-tab title="Carga">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="width: 30%">Unidade de medida*</th>
                                    <th style="width: 30%">Tipo de medida</th>
                                    <th style="width: 30%">Quantidade carga</th>
                                    <th style="width: 10%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr v-for="(row, index) in carga_medida" class="bg-gray-light" style="display: table-row;">
                                    <td>
                                      <b-col>
                                          <multiselect v-model="row.medida"
                                          :options="optionsParamUnidadeMedida"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.medida.value')" v-if="form.errors.has('carga_medida.'+index+'.medida.value')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td>
                                      <b-col>
                                          <multiselect v-model="row.tipomedida"
                                          :options="optionsParamTipoMedida"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.tipomedida.value')" v-if="form.errors.has('carga_medida.'+index+'.tipomedida.value')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td>
                                      <b-col>
                                          <b-form-input type="text"
                                                        placeholder=""
                                                        v-model="row.qtde_carga"
                                                        >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.qtde_carga')" v-if="form.errors.has('carga_medida.'+index+'.qtde_carga')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td>
                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCarga(index);"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <td></td><td></td><td></td>
                            <td>
                              <i class="fa fa-plus-square" v-on:click="addRowCarga($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                            </td>
                        </table>
                      </b-tab>
                      <b-tab title="Documentos">
                          <table class="table">
                              <thead>
                                  <tr>
                                      <th style="width: 20%">Emitente</th>
                                      <th style="width: 25%">Chave</th>
                                      <th style="width: 10%">Número Fiscal</th>
                                      <th style="width: 10%">Série</th>
                                      <th style="width: 15%">Data</th>
                                      <th style="width: 5%">Ação</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                      <td>
                                          {{ row.emi_nome }}
                                      </td>
                                      <td>
                                          {{ row.chave }}
                                      </td>
                                      <td>
                                          {{ row.num_fiscal }}
                                      </td>
                                      <td>
                                          {{ row.serie }}
                                      </td>
                                      <td>
                                          <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                      </td>
                                      <td>
                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </b-tab>
                      <b-tab title="Seguro">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="width: 45%">Responsável pelo seguro*</th>
                                    <th style="width: 45%">Seguradora</th>
                                    <th style="width: 5%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr v-for="(row, index) in seguro">
                                    <td>
                                      <b-col>
                                          <multiselect v-model="row.respseg"
                                          :options="optionsParamRespSeg"
                                          track-by="value"
                                          label="label"
                                          :hide-selected="true"
                                          placeholder="Selecione"
                                          tag-placeholder="Selecionar"
                                          select-label="Selecionar"
                                          selected-label="Selecionado"
                                          deselect-label="Remover"
                                          disabled
                                          ></multiselect>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td>
                                      <multiselect v-model="row.seguradora"
                                      :options="optionsSeguradora"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      disabled
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                                    </td>
                                    <td>
                                        <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSeguro(index);"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <td></td><td></td>
                            <td>
                              <i class="fa fa-plus-square" v-on:click="addRowSeguro($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                            </td>
                        </table>
                      </b-tab>
                      <b-tab title="Observações" >
                          <h4 class="panel-title">Observação Geral</h4>
                          <b-form-textarea id="textarea1"
                                           name="obs"
                                           v-model="form.obs"
                                           placeholder="Observação"
                                           :rows="6"
                                           :max-rows="6">
                          </b-form-textarea>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                          <h4 class="panel-title">Observação Fiscal</h4>
                          <b-form-textarea id="textarea1"
                                           name="obs_fiscal"
                                           v-model="form.obs_fiscal"
                                           placeholder="Observação Fiscal"
                                           :rows="6"
                                           :max-rows="6">
                          </b-form-textarea>
                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fiscal')" v-if="form.errors.has('obs_fiscal')"></b-form-feedback>
                          <h4 class="panel-title">Campos livres contribuinte</h4>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 45%">Campo</th>
                                        <th style="width: 45%">Valor</th>
                                        <th style="width: 10%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr v-for="(row, index) in obs_cont">
                                        <td>
                                          <b-col>
                                              <b-form-input type="text"
                                                          placeholder="Descrição"
                                                          v-model="row.xcampo"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xcampo')" v-if="form.errors.has('obs_cont.'+index+'.xcampo')"></b-form-feedback>
                                          </b-col>
                                        </td>
                                        <td>
                                          <b-col>
                                              <b-form-input type="text"
                                                          placeholder="Valor"
                                                          v-model="row.xtexto"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xtexto')" v-if="form.errors.has('obs_cont.'+index+'.xtexto')"></b-form-feedback>
                                          </b-col>
                                        </td>
                                        <td>
                                              <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsCont(index);"></i>
                                        </td>
                                    </tr>
                                </tbody>
                                <td></td><td></td>
                                <td>
                                  <i class="fa fa-plus-square" v-on:click="addRowObsCont($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                </td>
                            </table>
                            <h4 class="panel-title">Campos livres fisco</h4>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 45%">Campo</th>
                                        <th style="width: 45%">Valor</th>
                                        <th style="width: 10%">Ações</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                     <tr v-for="(row, index) in obs_fisco">
                                        <td>
                                          <b-col>
                                              <b-form-input type="text"
                                                          placeholder="Descrição"
                                                          v-model="row.xcampo"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xcampo')" v-if="form.errors.has('obs_fisco.'+index+'.xcampo')"></b-form-feedback>
                                          </b-col>
                                        </td>
                                        <td>
                                          <b-col>
                                              <b-form-input type="text"
                                                          placeholder="Valor"
                                                          v-model="row.xtexto"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xtexto')" v-if="form.errors.has('obs_fisco.'+index+'.xtexto')"></b-form-feedback>
                                          </b-col>
                                        </td>
                                        <td>
                                              <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsFisco(index);"></i>
                                        </td>
                                    </tr>
                                </tbody>
                                <td></td><td></td>
                                <td>
                                  <i class="fa fa-plus-square" v-on:click="addRowObsFisco($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                </td>
                            </table>
                      </b-tab>
                      <b-tab title="Comp. Frete" >
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="width: 45%">Componente</th>
                                    <th style="width: 45%">Valor</th>
                                    <th style="width: 10%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr v-for="(row, index) in comp_frete">
                                    <td>
                                        <multiselect v-model="row.custo"
                                        :options="optionsCustos"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        disabled
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.custo.value')" v-if="form.errors.has('comp_frete.'+index+'.custo.value')"></b-form-feedback>
                                    </td>
                                    <td>
                                      <b-col>
                                          <b-form-input type="text"
                                                      placeholder="Valor"
                                                      v-model="row.vlr"

                                                      readonly>
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.vlr')" v-if="form.errors.has('comp_frete.'+index+'.vlr')"></b-form-feedback>
                                      </b-col>
                                    </td>
                                    <td>
                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCompFrete(index);"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <td></td><td></td>
                            <td>
                              <i class="fa fa-plus-square" v-on:click="addRowCompFrete($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                            </td>
                        </table>
                      </b-tab>
                      <b-tab title="Documentos Anteriores" disabled>
                        <br>Documento Anterior de Transporte
                      </b-tab>
                    </b-tabs>
                </b-col>
              </b-row>
            </b-container>
          </form>
      </b-container>
      <div slot="modal-footer" class="w-100">
             <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
             <div class="float-right">
               <div class="float-left" v-if="this.errors_array.length>0">
               <b-btn class="label label-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

               <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                 <table class="table" id="mais">
                      <tbody>
                          <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                             <td>
                               {{ item.erro }}
                             </td>
                         </tr>
                     </tbody>
                 </table>
               </b-popover>
             </div>
             &nbsp;

                 <b-btn @click="showModalGerarCteAjustado=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="onStore($event)" variant="primary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
             </div>
      </div>
  </b-modal>
</template>

<script>
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'

export default {
    components: {
        VMoney,
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          showModalSelect: false,
          showModalSel: false,
          showPopover: false,
          showModalGerarCteAjustado: false,
          optionsParamMotivo: [],
          optionsExpedidor: [],
          optionsRecebedor: [],
          optionsTomador: [],
          optionsCfop: [],
          optionsLivTpServico: [],
          optionsBModal: [],
          optionsModelo: [],
          isLoadingExp: false,
          isLoadingRec: false,
          isLoadingTom: false,
          helpForm: new Form({statusRecord: [], params: [], search:''}),
          vn_vlr_cte: 0,
          vn_aliquota: 0,
          vn_percentual_reducao_bc: 0,
          vv_kg_uni_med: '',
          vn_parunidmed_id: 0,
          vv_medida_peso_bruto: '',
          vn_partpmed_id: 0,
          activateDesativate: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsPortoOrigem: [],
          optionsPortoTransbordo: [],
          optionsPortoDestino: [],
          optionsPortoOrigem: [],
          optionsEmbarcacao: [],
          optionsParamCst: [],
          optionsParamUnidadeMedida: [],
          optionsParamTipoMedida: [],
          optionsParamRespSeg: [],
          optionsSeguradora: [],
          optionsCustos: [],
          obs_cont: [],
          obs_fisco: [],
          docfis: [],
          Icms: [],
          carga_doc: [],
          /*{ aliquota_contribuinte: 0
                , aliquota_nao_contribuinte: 0
                , uf_ini: ''
                , uf_fim: ''
          },*/
          errors_array: [],
          carga_medida: [ { medida: [],
                     tipomedida: [],
                     qtde_carga: ''}],

          seguro: [ { respseg: [],
                      seguradora: []}],

          comp_frete: [ {pedparcfr_id: '',
                     vlr: '',
                     custo: [],}],
          vlr: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          percentual_reducao_bc: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          aliquota: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          qtd: {
              decimal: ',',
              thousands: '.',
              precision: 3,
              masked: false /* doesn't work with directive */
          },
          form: new Form({
                    cst: [],
                    chave_cte_multi: '',
                    chave: '',
                    modal: '',
                    cfop: [],
                    rntrc: '',
                    tp_servico: [],
                    tp_cte: 0,
                    tp_valor_carga: "",
                    tp_valor_advalorem: "",
                    municipio_ini: [],
                    municipio_fim: [],
                    produto_predominante: '',
                    vlr_cte: 0,
                    vlr_carga_averbacao: 0,
                    vlr_aliquota: 0,
                    vlr_imposto: 0,
                    vlr_total: 0,
                    percentual_reducao_bc: 0,
                    docfis: [],
                    porto_origem: [],
                    porto_transbordo: [],
                    porto_destino: [],
                    embarcacao: [],
                    num_viagem: '',
                    recebedor: [],
                    expedidor: [],
                    tomador: '',
                    tomador_outros: [],
                    obs: '',
                    obs_fiscal: '',
                    vlr_aliquota_afrmm: '',
                    tp_orig_doc: 2,
                    bmodal: [],
                    carga_medida: [],
                    seguro: [],
                    obs_cont: [],
                    obs_fisco: [],
                    comp_frete: [],
                    carga_doc: [],
                    globalizado: [],
                }),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'num_fiscal',
              title: 'Número Fiscal'
            },
            {
              name: 'serie',
              title: 'Serie'
            },
            {
              name: 'dt_emissao',
              title: 'Data Emissão',
              callback: 'formatDate|DD/MM/YYYY'
            },
            {
              name: 'doc_fiscal_partes_env.emi_cnpj',
              title: 'CNPJ'
            },
            {
              name: 'doc_fiscal_partes_env.emi_nome',
              title: 'Razão Social'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.moreParams = {
                'num_fiscal':  data_filter.num_fiscal,
                'emi_cnpj':  data_filter.emi_cnpj,
                'chave':  data_filter.chave,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
        },
        onCreate (pedido_unidade_carga) {
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.form.reset();
            this.form.produto_predominante = pedido_unidade_carga.pedido.produto_predominante;
            this.form.tomador = pedido_unidade_carga.pedido.tomador;
            this.form.tp_valor_carga = pedido_unidade_carga.pedido.tp_valor_carga;
            this.form.tp_valor_advalorem = pedido_unidade_carga.pedido.tp_valor_advalorem;

            if(pedido_unidade_carga.pedido.obs_cte!==null)
            {
                this.form.obs = pedido_unidade_carga.pedido.obs_cte;
            }

            if(pedido_unidade_carga.pedido.obs_cte_fiscal!==null)
            {
                this.form.obs_fiscal = pedido_unidade_carga.pedido.obs_cte_fiscal;
            }

            if(pedido_unidade_carga.pedido.b_modal!==null)
            {
                this.form.bmodal = { label: pedido_unidade_carga.pedido.b_modal.cd+" - "+pedido_unidade_carga.pedido.b_modal.descr, value: pedido_unidade_carga.pedido.b_modal.bmodal_id };
            }
            else
            {
                this.form.bmodal = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.cfop!==null)
            {
                this.form.cfop = { label: pedido_unidade_carga.pedido.cfop.cd+" - "+pedido_unidade_carga.pedido.cfop.descr, value: pedido_unidade_carga.pedido.cfop.cfop_id };
            }
            else
            {
                this.form.cfop = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.param_cst!==null)
            {
                this.form.cst = { label: pedido_unidade_carga.pedido.param_cst.cd+" - "+pedido_unidade_carga.pedido.param_cst.descr, value: pedido_unidade_carga.pedido.param_cst.parcst_id, cd: pedido_unidade_carga.pedido.param_cst.cd};
            }
            else
            {
                this.form.cfop = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.municipio_inicio!==null)
            {
                this.form.municipio_ini = { label: pedido_unidade_carga.pedido.municipio_inicio.nome, value: pedido_unidade_carga.pedido.municipio_inicio.municipio_id, uf: pedido_unidade_carga.pedido.municipio_inicio.uf_id };
            }
            else
            {
                this.form.municipio_ini = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.municipio_fim!==null)
            {
                this.form.municipio_fim = { label: pedido_unidade_carga.pedido.municipio_fim.nome, value: pedido_unidade_carga.pedido.municipio_fim.municipio_id, uf: pedido_unidade_carga.pedido.municipio_fim.uf_id };
            }
            else
            {
                this.form.municipio_fim = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.tp_servico!==null)
            {
                this.form.tp_servico = { label: pedido_unidade_carga.pedido.tp_servico.descr, value: pedido_unidade_carga.pedido.tp_servico.valor };
            }
            else
            {
                this.form.tp_servico = {label: "Selecione"};
            }

            if(pedido_unidade_carga.pedido.tp_c_frete!==null)
            {
                this.form.tp_cfrete = { label: pedido_unidade_carga.pedido.tp_c_frete.descr, value: pedido_unidade_carga.pedido.tp_c_frete.valor };
            }
            else
            {
                this.form.tp_cfrete = {label: "Selecione"};
            }


            if(pedido_unidade_carga.pedido==4 && pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica!==null)
            {
                this.form.tomador_outros = { label: pedido_unidade_carga.pedido.pessoa_tomador.cd+" - "+pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.cnpj_base,pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.cnpj_filial,pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.cnpj_digito)+" - "+pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.inscricao_estadual, value: pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica.pessoa_id };
            }

            if(pedido_unidade_carga.pedido==4 && pedido_unidade_carga.pedido.pessoa_tomador.pessoa_juridica==null)
            {
                this.form.tomador_outros = {label: "Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"};
            }

            this.comp_frete = null;
            this.comp_frete = [];
            var vb_comp_frete = true;
            pedido_unidade_carga.pedido.pedido_param_comp_frete.forEach((obj)=>{
                var vn_vlr_comp_frete = 0;
                if(obj.insere_advalorem==1
                && pedido_unidade_carga.vlr_total_advalorem>0
                && pedido_unidade_carga.pedido.exibe_advalorem_cfrete==2
                && vb_comp_frete==true)
                {
                    vn_vlr_comp_frete = parseFloat(obj.vlr)+parseFloat(pedido_unidade_carga.vlr_total_advalorem);
                    vb_comp_frete = false;
                }
                else
                {
                    vn_vlr_comp_frete = obj.vlr;
                }

                this.comp_frete.push({pedparcfr_id:obj.pedparcfr_id, custo: {label: obj.custo.descr, value: obj.custo.custo_id}, vlr: this.formatNumber(vn_vlr_comp_frete) })
            });

            // Vai adicionar o Advalorem nos componentes de frete
            if(pedido_unidade_carga.vlr_total_advalorem>0 && pedido_unidade_carga.pedido.exibe_advalorem_cfrete==1)
            {
                if(pedido_unidade_carga.pedido.bcliente.b_config_blogistic.custo_advalorem==undefined)
                {
                    var obj = {
                      isShown: true,
                      title: 'Custo de Advalorem não definido',
                      message: 'Atenção, favor configurar o custo de Advalorem na tela de conta',
                      type: 'error',
                      customCloseBtnText: 'Fechar'
                    }
                    this.$Simplert.open(obj);
                    return;
                }
                // Busca o BConfig BLogistic para popular
                this.comp_frete.push({pedparcfr_id: -1, custo: {label: pedido_unidade_carga.pedido.bcliente.b_config_blogistic.custo_advalorem.descr, value: pedido_unidade_carga.pedido.bcliente.b_config_blogistic.custo_advalorem.custo_id}, vlr: this.formatNumber(pedido_unidade_carga.vlr_total_advalorem) })
            }

            // Carga doc
            this.carga_medida = null;
            this.carga_medida = [];
            this.qtde_carga = 0;
            var obs_carga = "";
            var tag_container = "";
            var tag_lacre = "";
            var tag_num_pedido = "";
            var tag_peso_bruto = "";
            var tag_advalorem_percentual = "";
            var tag_advalorem_valor = "";
            var peso_bruto = 0;
            pedido_unidade_carga.carga_doc_unidade_carga.forEach((obj)=>{
               obj.carga_doc.forEach((obj2)=>{
                   if(obj2.doc_fiscal!==null)
                   {
                      if(obj2.doc_fiscal.doc_fiscal_transporte!==null)
                      {
                          obj2.doc_fiscal.doc_fiscal_transporte.doc_fiscal_transporte_volume.forEach((obj3)=>{
                              peso_bruto = parseFloat(peso_bruto)+parseFloat(obj3.peso_bruto);
                          });
                          this.carga_medida.push({ qtde_carga: this.formatNumberQtd(peso_bruto.toFixed(3)), medida: {label: this.vv_kg_uni_med, value: this.vn_parunidmed_id}, tipomedida: {label: this.vv_medida_peso_bruto, value: this.vn_partpmed_id} })
                      }

                      tag_peso_bruto = this.formatNumber(peso_bruto);

                      if(tag_container=="")
                      {
                          tag_container = obj2.carga.num_container;
                      }
                      else
                      {
                          tag_container = "/"+obj2.carga.num_container;
                      }

                      if(tag_lacre=="")
                      {
                          tag_lacre = obj2.carga.num_lacre;
                      }
                      else
                      {
                          tag_lacre = "/"+obj2.carga.num_lacre;
                      }

                      obs_carga = obj2.carga.obs;
                  }
               });
            });

            if(pedido_unidade_carga.pedido.percentual_advalorem!=undefined)
            {
                var tag_advalorem_percentual = pedido_unidade_carga.pedido.percentual_advalorem;
            }

            if(pedido_unidade_carga.vlr_total_advalorem!=undefined)
            {
                var tag_advalorem_valor = this.formatNumber(pedido_unidade_carga.vlr_total_advalorem);
            }
            var tag_num_pedido = pedido_unidade_carga.pedido.num_pedido;

            if(obs_carga!==null)
            {
                var obs_completa = this.form.obs+" - "+obs_carga;
            }
            else
            {
                var obs_completa = this.form.obs;
            }

            obs_completa = obs_completa.replace("#container", tag_container);
            obs_completa = obs_completa.replace("#lacre", tag_lacre);
            obs_completa = obs_completa.replace("#peso_bruto", tag_peso_bruto);
            obs_completa = obs_completa.replace("#num_pedido", tag_num_pedido);
            obs_completa = obs_completa.replace("#advalorem_percentual", tag_advalorem_percentual);
            this.form.obs = obs_completa;

            // Observação Fiscal
            var obs_completa_fiscal = this.form.obs_fiscal+"";
            obs_completa_fiscal = obs_completa_fiscal.replace("#container", tag_container);
            obs_completa_fiscal = obs_completa_fiscal.replace("#lacre", tag_lacre);
            obs_completa_fiscal = obs_completa_fiscal.replace("#peso_bruto", tag_peso_bruto);
            obs_completa_fiscal = obs_completa_fiscal.replace("#num_pedido", tag_num_pedido);
            obs_completa_fiscal = obs_completa_fiscal.replace("#advalorem_percentual", tag_advalorem_percentual);
            this.form.obs_fiscal = obs_completa_fiscal;

            this.docfis = null;
            this.docfis = [];
            this.carga_doc = null;
            this.carga_doc = [];
            pedido_unidade_carga.carga_doc_unidade_carga.forEach((obj)=>{
                obj.carga_doc.forEach((obj2)=>{
                    if(obj2.docfis_id!=null)
                    {
                        this.carga_doc.push({ cardoc_id: obj2.cardoc_id, docfis_id: obj2.docfis_id });
                        this.docfis.push({ id: obj2.doc_fiscal.docfis_id, num_fiscal: obj2.doc_fiscal.num_fiscal,  serie: obj2.doc_fiscal.serie, chave: obj2.doc_fiscal.chave, dt_emissao: obj2.doc_fiscal.dt_emissao, emi_nome: obj2.doc_fiscal.doc_fiscal_partes_env.emi_nome});
                    }
                    // Inserir doc anterior
                });
            });

            this.seguro = null;
            this.seguro = [];
            pedido_unidade_carga.pedido.pedido_param_seguro.forEach((obj)=>{
                this.seguro.push({respseg: { value: obj.param_tipo_resp_seg.partprese_id, label: obj.param_tipo_resp_seg.descr },
                                  seguradora: { value: obj.seguradora.segurado_id, label: obj.seguradora.nome+' - '+obj.seguradora.apolice }});
            });

            // Vai buscar a aliquota
            this.Icms.forEach((obj)=>{
                if(obj.uf_fim==pedido_unidade_carga.pedido.municipio_fim.uf.cd && obj.uf_ini==pedido_unidade_carga.pedido.municipio_inicio.uf.cd)
                {
                    this.form.vlr_aliquota = Number(this.formatNumberInterno(obj.aliquota_contribuinte)).toFixed(2).toString().replace(".", ",");
                }
            });

            // Somatória dos custos
            this.form.vlr_total = Number(pedido_unidade_carga.vlr_total).toFixed(2).toString().replace(".", ",");
            this.calcCteVlrTotal();
            this.showModalGerarCteAjustado = true;

        },
        calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte.replace( ".", "" );
            this.vn_vlr_cte = this.vn_vlr_cte.replace( ",", "." );
            this.vn_vlr_cte = parseFloat( this.vn_vlr_cte.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte).toFixed(2);
            this.form.vlr_total = Number(parseFloat(this.vn_vlr_cte)+parseFloat(this.form.vlr_imposto)).toFixed(2);
        },
        calcCteVlrTotal() {
            this.vn_vlr_total = this.form.vlr_total.replace( ".", "" );
            this.vn_vlr_total = this.vn_vlr_total.replace( ",", "." );
            this.vn_vlr_total = parseFloat( this.vn_vlr_total.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.vn_vlr_cte = Number(this.vn_vlr_total*((100-this.vn_aliquota)/100)).toFixed(2); // .toString().replace(".", ",");;
            this.form.vlr_cte = this.vn_vlr_cte.toString().replace(".", ",");

            this.vn_vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte).toFixed(2); // .toString().replace(".", ",");;
            this.form.vlr_imposto = this.vn_vlr_imposto.toString().replace(".", ",");

        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            // O store espera modal com o código
            this.form.tp_orig_doc = 2; // Ajustado
            this.form.modal = this.form.bmodal.value;
            this.form.carga_medida = this.carga_medida;
            this.form.carga_doc = this.carga_doc;
            this.form.seguro = this.seguro;
            this.form.obs_cont = this.obs_cont;
            this.form.obs_fisco = this.obs_fisco;
            this.form.comp_frete = this.comp_frete;
            this.form.docfis = this.docfis;
            this.form.globalizado = {value: 2};
            this.form.post('/api/gerarcte/store').then(response =>
            {
                new ReturnApi(response, this);
                this.$parent.$refs.vuetable.reload();
            })
            .catch(errors =>
            {

                new ReturnApi(errors, this);
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        getLivGeral() {
            this.helpForm.get('/api/gerarcte/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.param_cst.forEach((obj)=>
                {
                    this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id, cd: obj.cd })
                })
                response.cfops.forEach((obj)=>
                {
                    this.optionsCfop.push({ label: obj.cd+" - "+obj.descr, value: obj.cfop_id })
                })

                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
                })

                response.bmodal.forEach((obj)=>
                {
                    this.optionsBModal.push({ label: obj.cd+" - "+obj.descr, value: obj.bmodal_id })
                })
                response.municipios.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id, uf: obj.uf_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id, uf: obj.uf_id })
                })
                response.portos.forEach((obj)=>
                {
                    this.optionsPortoOrigem.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoTransbordo.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoDestino.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                })
                response.embarcacao.forEach((obj)=>
                {
                    this.optionsEmbarcacao.push({ label: obj.nome+" - "+obj.irin, value: obj.embarcacao_id })
                })
                response.medida.forEach((obj)=>
                {
                    this.optionsParamUnidadeMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.parunidmed_id })
                    if(obj.cd=="01")
                    {
                        this.vv_kg_uni_med = obj.descr+" - "+obj.cd;
                        this.vn_parunidmed_id = obj.parunidmed_id;
                    }
                })
                response.tipomedida.forEach((obj)=>
                {
                    this.optionsParamTipoMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.partpmed_id })
                    if(obj.cd=="2")
                    {
                        this.vv_medida_peso_bruto = obj.descr+" - "+obj.cd;
                        this.vn_partpmed_id = obj.partpmed_id;
                    }
                })

                response.respseg.forEach((obj)=>
                {
                    this.optionsParamRespSeg.push({ label: obj.descr+" - "+obj.cd, value: obj.partprese_id })
                })

                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome+" - "+obj.apolice, value: obj.segurado_id })
                })

                response.custos.forEach((obj)=>
                {
                    this.optionsCustos.push({ label: obj.descr+" - "+obj.cd, value: obj.custo_id })
                })

                response.icms.forEach((obj)=>
                {
                    this.Icms.push({ aliquota_contribuinte: obj.aliquota_contribuinte, aliquota_nao_contribuinte: obj.aliquota_nao_contribuinte, uf_ini: obj.uf_ini.cd, uf_fim: obj.uf_fim.cd })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesExpedidor(search) {
            if(search.length>=3)
            {
                this.isLoadingExp = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsExpedidor = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesRecebedor(search) {
            if(search.length>=3)
            {
                this.isLoadingRec = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsRecebedor = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsRecebedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingRec = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
            var cnpj_formatado
            var pad = "00000000";
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
            return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
        },
        addRowCompFrete: function(e) {
            e.preventDefault();
            this.comp_frete.push({
                custo: "",
                vlr: "",
            });
        },
        removeRowCompFrete: function(index) {
            this.comp_frete.splice(index, 1);
        },
        addRowObsCont: function(e) {
            e.preventDefault();
            this.obs_cont.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsCont: function(index) {
            this.obs_cont.splice(index, 1);
        },
        addRowObsFisco: function(e) {
            e.preventDefault();
            this.obs_fisco.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsFisco: function(index) {
            this.obs_fisco.splice(index, 1);
        },
        addRowSeguro: function(e) {
            e.preventDefault();
            this.seguro.push({
                seguradora: [],
                partprese: [],
            });
        },
        removeRowSeguro: function(index) {
            this.seguro.splice(index, 1);
        },
        addRowCarga: function(e) {
            e.preventDefault();
            this.carga_medida.push({
                partpmed: [],
                parunidmed: [],
                qtde_carga: '',
                vlr_carga_averbacao: ''
            });
        },
        removeRowDoc: function(index) {
            this.docfis.splice(index, 1);
        },
        removeRowCarga: function(index) {
            this.carga_medida.splice(index, 1);
        },
        addRowDoc: function(e) {
            e.preventDefault();
            this.docfis.push({
                chave: ''
            });
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatNumberQtd (value) {
            return accounting.formatNumber(value, 3, '.', ',')
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
